import React, { useEffect, useState } from 'react'
import Icon from '@mdi/react'
import { mdiContentCopy, mdiLinkVariant, mdiQrcode } from '@mdi/js'
import { t } from '../i18n'
import { qrDataUrlForText } from '../utils/studyShareLink'

/**
 * Enlace + QR del estudio (ticket ?t=).
 */
function StudyShareLinkSection({ shareUrl, busy, onCopyLink, onShareLink, portalMode = false }) {
  const [qrSrc, setQrSrc] = useState(null)

  useEffect(() => {
    let cancelled = false
    if (!shareUrl) {
      setQrSrc(null)
      return undefined
    }
    qrDataUrlForText(shareUrl, { width: 180 }).then((dataUrl) => {
      if (!cancelled) setQrSrc(dataUrl)
    })
    return () => {
      cancelled = true
    }
  }, [shareUrl])

  if (!shareUrl) return null

  return (
    <div className="udv-share-section">
      <div className="udv-share-section-label">{t('share.sectionStudyLink')}</div>
      <p className="udv-share-btn-sub" style={{ margin: '0 0 10px', lineHeight: 1.45 }}>
        {t(portalMode ? 'share.portalStudyLinkHint' : 'share.studyLinkHint')}
      </p>
      <div className="udv-share-study-link-row">
        <input
          className="udv-share-study-link-input"
          type="text"
          readOnly
          value={shareUrl}
          aria-label={t('share.studyLink')}
          onFocus={(e) => e.target.select()}
        />
      </div>
      <div className="udv-share-actions" style={{ marginTop: 8 }}>
        <button
          type="button"
          className={`udv-share-btn${busy ? ' is-busy' : ''}`}
          disabled={busy}
          onClick={() => onCopyLink && onCopyLink()}
        >
          <Icon path={mdiContentCopy} size={0.9} color="currentColor" />
          <span className="udv-share-btn-label">{t('share.copyStudyLink')}</span>
        </button>
        {onShareLink ? (
          <button
            type="button"
            className={`udv-share-btn${busy ? ' is-busy' : ''}`}
            disabled={busy}
            onClick={() => onShareLink()}
          >
            <Icon path={mdiLinkVariant} size={0.9} color="currentColor" />
            <span className="udv-share-btn-label">{t('share.shareStudyLink')}</span>
          </button>
        ) : null}
      </div>
      {qrSrc ? (
        <div className="udv-share-qr-wrap" aria-hidden={false}>
          <div className="udv-share-qr-label">
            <Icon path={mdiQrcode} size={0.75} color="currentColor" />
            <span>{t('share.studyLinkQr')}</span>
          </div>
          <img
            className="udv-share-qr-img"
            src={qrSrc}
            width={180}
            height={180}
            alt={t('share.studyLinkQrAlt')}
          />
        </div>
      ) : null}
    </div>
  )
}

export default StudyShareLinkSection
